
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceHsnDialog extends Serenity.EntityDialog<InvoiceHsnRow, any> {
        protected getFormKey() { return InvoiceHsnForm.formKey; }
        protected getIdProperty() { return InvoiceHsnRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceHsnRow.localTextPrefix; }
        protected getService() { return InvoiceHsnService.baseUrl; }
        protected getDeletePermission() { return InvoiceHsnRow.deletePermission; }
        protected getInsertPermission() { return InvoiceHsnRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceHsnRow.updatePermission; }

        protected form = new InvoiceHsnForm(this.idPrefix);

    }
}